import { EMPTY_OBJECT } from '../../../constants/common'
import {
  filterPermittedActionsWithDividers,
  parseActionsOnValidDivider,
} from '../../../utils/massActions'
import { getSelectDropdownListDividerOption } from '../../Select'
import {
  CHATROOM_MESSAGE_ACTION_ATTACH_REQUEST,
  CHATROOM_MESSAGE_ACTION_CREATE_REQUEST,
  CHATROOM_MESSAGE_ACTION_DELETE,
  CHATROOM_MESSAGE_ACTION_EDIT,
} from '../Chatroom.constants'

export function getChatroomMessageActionsItems({
  message,
  t,
  onClickAttachRequest,
  onClickCreateRequest,
  onClickDelete,
  onClickEdit,
}) {
  const permissions = message?.permissions || EMPTY_OBJECT

  const items = [
    {
      label: t('Chatroom.MessageActionEditKey'),
      permission: permissions.can_edit,
      value: CHATROOM_MESSAGE_ACTION_EDIT,
      onClick: onClickEdit,
    },
    {
      label: t('Chatroom.MessageActionCreateRequestKey'),
      permission: permissions.can_attach_service_request,
      value: CHATROOM_MESSAGE_ACTION_CREATE_REQUEST,
      onClick: onClickCreateRequest,
    },
    {
      label: t('Chatroom.MessageActionAttachRequestKey'),
      permission: permissions.can_attach_service_request,
      value: CHATROOM_MESSAGE_ACTION_ATTACH_REQUEST,
      onClick: onClickAttachRequest,
    },
    getSelectDropdownListDividerOption(),
    {
      label: t('Chatroom.MessageActionDeleteKey'),
      permission: permissions.can_delete,
      value: CHATROOM_MESSAGE_ACTION_DELETE,
      onClick: onClickDelete,
    },
  ]

  return parseActionsOnValidDivider(filterPermittedActionsWithDividers(items))
}
